<ea-svg [svgClass]="setIconClass()" [class]="setMaskClass()" [minWidth]="size" [minHeight]="size" [width]="size" [height]="size"></ea-svg>
